import { createContext } from 'react';
import { FCProps } from 'types/FCProps';

import { ICertificationsDataCtx } from './types';
import { certificationsInitialValues } from './utils';

import useCertificationsContent from 'hooks/useCertificationsContent';

export const CertificationContext = createContext<ICertificationsDataCtx>(
  certificationsInitialValues
);

const CertificationsProvider = ({ children }: FCProps): JSX.Element => {
  const {
    counters,
    voucherSummary,
    fetching,
    fetchingCounters,
    fetchingVoucherSummary,
    fetchingUsers,
    fetchingTable,
    fetchingCertificationOptions,
    isFirstFetching,
    certificationOptions,
    users,
    usersTable,
    usersCount,
    emptyState,
    filters,
    changeFilters,
    getUsers,
    loadingMoreUsers,
    assignableUsers,
    assignableUsersCount,
    fetchingAssignableUsers,
    getAssignableUsers,
    assignVouchers,
  } = useCertificationsContent();

  const actions = {
    onChangeFilters: changeFilters,
  };

  return (
    <CertificationContext.Provider
      value={{
        counters,
        voucherSummary,
        fetching,
        fetchingUsers,
        fetchingCounters,
        fetchingVoucherSummary,
        fetchingTable,
        fetchingCertificationOptions,
        isFirstFetching,
        certificationOptions,
        users,
        usersCount,
        usersTable,
        emptyState,
        filters,
        actions,
        getUsers,
        loadingMoreUsers,
        assignableUsers,
        assignableUsersCount,
        fetchingAssignableUsers,
        getAssignableUsers,
        assignVouchers,
      }}
    >
      {children}
    </CertificationContext.Provider>
  );
};

export default CertificationsProvider;
